import styles from "./Button.module.css";

type ButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  variant?: "primary" | "secondary" | "cta" | "large";
  className?: string;
  testId?: string;
  ariaLabel?: string;
};

type LinkButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  className?: string;
  testId?: string;
};

type IconButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  title?: string;
  type?: "button" | "submit" | "reset";
  variant?: "muted" | "info" | "inline";
  active?: boolean;
  className?: string;
  testId?: string;
  ariaExpanded?: boolean;
  ariaControls?: string;
};

export const LinkButton = ({ children, onClick, type = "button", disabled, className, testId }: LinkButtonProps) => (
  <button
    className={[styles.linkButton, className].filter(Boolean).join(" ")}
    data-testid={testId}
    onClick={(e) => {
      e.preventDefault();
      onClick?.();
    }}
    type={type}
    disabled={disabled}
  >
    {children}
  </button>
);

const Button = ({ children, onClick, type = "submit", disabled, variant = "primary", className, testId, ariaLabel }: ButtonProps) => (
  <button
    aria-label={ariaLabel}
    className={[styles.button, variant !== "primary" && styles[variant], className].filter(Boolean).join(" ")}
    data-testid={testId}
    onClick={(e) => {
      if (onClick) {
        e.preventDefault();
        onClick();
      }
    }}
    type={type}
    disabled={disabled}
  >
    {children}
  </button>
);

export const IconButton = ({
  children,
  onClick,
  title,
  type = "button",
  disabled,
  variant,
  active,
  className,
  testId,
  ariaExpanded,
  ariaControls,
}: IconButtonProps) => (
  <button
    aria-controls={ariaControls}
    aria-expanded={ariaExpanded}
    className={[
      styles.iconButton,
      variant && styles[variant],
      active && styles.active,
      className,
    ].filter(Boolean).join(" ")}
    data-testid={testId}
    onClick={(e) => {
      e.preventDefault();
      onClick?.();
    }}
    title={title}
    type={type}
    disabled={disabled}
  >
    {children}
  </button>
);

export default Button;
